import { Box } from '@mui/joy';

import { CorporatePartCostList } from 'corporate/components/CorporatePartCostList';
import { ICorporatePart } from 'corporate/types';
import { IExternalPricesResponse } from 'parts/types';

import { AlternateCosts } from './AlternateCosts';
import { PartDetailsTab } from '../enums';
import { usePartDetailsScrollToFocus } from '../hooks';

interface IProps {
  corporatePart: Partial<ICorporatePart>;
  partNumber: string;
  manufacturerId: number;
  externalPricing?: IExternalPricesResponse | null;
  isAlternateVersionEnabled?: boolean;
  enabled?: boolean;
  fullWidth?: boolean;
  isLoading?: boolean;
}

const MIN_ROWS_FOR_FOCUS_TRIGGER = 3;

export const Costs = ({
  corporatePart,
  partNumber,
  manufacturerId,
  externalPricing,
  isAlternateVersionEnabled,
  enabled,
  fullWidth,
  isLoading,
}: IProps) => {
  const { panelScrollAnchorRef, onBodyScroll } = usePartDetailsScrollToFocus(PartDetailsTab.COSTS, {
    minRowsForTrigger: MIN_ROWS_FOR_FOCUS_TRIGGER,
  });

  if (isAlternateVersionEnabled) {
    return (
      <Box ref={panelScrollAnchorRef} sx={{ display: 'contents' }}>
        <AlternateCosts
          partNumber={partNumber}
          manufacturerId={manufacturerId}
          externalPricing={externalPricing}
          enabled={enabled}
          fullWidth={fullWidth}
        />
      </Box>
    );
  }

  return (
    <Box ref={panelScrollAnchorRef} sx={{ display: 'contents' }}>
      <CorporatePartCostList
        enabled={enabled}
        corporatePart={corporatePart}
        partNumber={partNumber}
        manufacturerId={manufacturerId}
        fullWidth={fullWidth}
        isLoading={isLoading}
        onBodyScroll={onBodyScroll}
      />
    </Box>
  );
};
